import React from 'react';
import { GrSearch } from 'react-icons/gr';

type Props = {
    placeholder?: string;
    value: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const SearchInput: React.FC<Props> = ({ placeholder, value, onChange }) => {
    return (
        <div className="flex items-center common_search py-2 px-4 rounded-full bg-white">
            <input
                placeholder={placeholder || 'Search ...'}
                value={value}
                onChange={onChange}
                className="w-full pr-2"
            />
            <div className="searchinput_icon">
                <GrSearch />
            </div>
        </div>
    );
};

export default SearchInput;
